<!--
 * @Author: zfd
 * @Date: 2020-08-21 17:24:24
 * @LastEditTime: 2020-08-23 16:44:37
 * @Description: 
 * @FilePath: \trip-manage\src\components\NavButton.vue
-->
<template>
  <div :class="classObject">
    <i :class="iconClass" @click="openView">{{ " " + title + " " }} </i>
    <i
      v-if="!isRequired"
      class="el-icon-close mouse-pointer"
      @click="closeView"
    >
    </i>

    <!-- fa fa-home -->
  </div>
</template>
<script>
export default {
  name: "NavButton",
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: "",
    },
    isSelected: {
      type: [Boolean, String],
      default: false,
    },
    isRequired: {
      type: [Boolean, String],
      default: false,
    },
    url: {
      required: true,
      type: String,
      default: "/",
    },
  },
  computed: {
    classObject() {
      if (this.isSelected) {
        //selected
        return "nav-selected";
      }
      return "nav-button";
    },
    iconClass() {
      if (this.icon) {
        return this.icon;
      }
      return this.icon;
    },
  },
  methods: {
    closeView() {
      // console.log('navButton',this.url);
      this.$store.dispatch("nav/closeView", this.url);
      this.$router.push(this.$store.state.nav.currentNav.url);
      //this.$emit('close-view',this.closeEvent);
    },
    openView() {
      // console.log('navButtonOpen',this.url);
      this.$store.dispatch("nav/openView", { url: this.url });
      this.$router.push(this.$store.state.nav.currentNav.url);
      //this.$emit('switch-view',this.switchEvent);
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.nav-button {
  color: white;
  font-size: 14px;
  background-color: #416ebf;
  height: 24px;
  width: max-content;
  line-height: 24px;
  margin-right: 10px;
  padding: 0 5px;
}
.nav-selected {
  font-size: 14px;
  height: 26px;
  width: max-content;
  line-height: 26px;
  margin-right: 10px;
  padding: 0 5px;
  background-color: white;
  color: #416ebf;
}
</style>
